import * as Sentry from '@sentry/react';
import { reactRouterBrowserTracingIntegration } from '@sentry/react/react-router';

const DEFAULT_TRACES_SAMPLE_RATE = 0.2;

let tracesSampleRate = DEFAULT_TRACES_SAMPLE_RATE;

/**
 * Applies the traces sample rate from the public system settings once they
 * are loaded. Anything outside 0 to 1 (or no value at all) falls back to the
 * default rate.
 */
export const setTracesSampleRate = (rate: unknown): void => {
  tracesSampleRate =
    typeof rate === 'number' && rate >= 0 && rate <= 1
      ? rate
      : DEFAULT_TRACES_SAMPLE_RATE;
};

// the DSN is only set for deployed builds, local and e2e builds report nothing
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [reactRouterBrowserTracingIntegration()],
    environment: import.meta.env.MODE,
    tracesSampler: ({ inheritOrSampleWith }) =>
      inheritOrSampleWith(tracesSampleRate),
    maxBreadcrumbs: 50,
    debug: import.meta.env.DEV,
  });
}
